import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loader: false,
};

const LoaderSlice = createSlice({
  name: "google loader",
  initialState,
  reducers: {
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
  },
});

export const { setLoader } =
LoaderSlice.actions;
export default LoaderSlice.reducer;



